import { createCountSheetsApiClient, type CountSheetsApiClient } from '@peritasai/data-access';
import type { CountSheetListQueryParams, CreateCountSheetDto, ReplaceCountSheetDto } from '@peritasai/types';
import { CountSheetEntity } from './count-sheet.entity';

export class CountSheetsRepository {
  constructor(private readonly apiClient: CountSheetsApiClient) {}

  async getCountSheets(): Promise<CountSheetEntity[]> {
    const dtos = await this.apiClient.getCountSheets();
    return dtos.map((dto) => new CountSheetEntity(dto));
  }

  async getPagedCountSheets(
    params: CountSheetListQueryParams
  ): Promise<{ data: CountSheetEntity[]; total: number; page: number; limit: number }> {
    const result = await this.apiClient.getPagedCountSheets(params);
    return {
      data: result.data.map((dto) => new CountSheetEntity(dto)),
      total: result.total,
      page: result.page,
      limit: result.limit,
    };
  }

  async createCountSheet(dto: CreateCountSheetDto): Promise<CountSheetEntity> {
    const result = await this.apiClient.createCountSheet(dto);
    return new CountSheetEntity(result);
  }

  async replaceCountSheet(id: string, dto: ReplaceCountSheetDto): Promise<CountSheetEntity> {
    const result = await this.apiClient.replaceCountSheet(id, dto);
    return new CountSheetEntity(result);
  }

  async getCountSheetById(id: string): Promise<CountSheetEntity> {
    const result = await this.apiClient.getCountSheetById(id);
    return new CountSheetEntity(result);
  }

  async searchCountSheets(trayType: string): Promise<CountSheetEntity | null> {
    const result = await this.apiClient.searchCountSheets(trayType);
    return result ? new CountSheetEntity(result) : null;
  }
}

export const countSheetsRepository = new CountSheetsRepository(createCountSheetsApiClient());
